const columnasEstadoCuenta = [
    { name: 'Descripción', id: 0, type: 'text', resaltado: false, text: '', },
    { name: 'Cuota Autorizada MINEDUC', id: 1, type: 'text', resaltado: false, text: '', },
    { name: 'Descuento Obtenido', id: 2, type: 'text', resaltado: false, text: '', },
    { name: 'Monto', id: 3, type: 'text', resaltado: false, text: '', },
    { name: 'Saldo', id: 7, type: 'text', resaltado: true, color: 'bg-azulBrillanteMira', text: '', },
    { name: 'Fecha Cobrado / Venció', id: 8, type: 'text', resaltado: true, color: 'bg-azulBrillanteMira', text: '', },
    { name: 'Documento', id: 9, type: 'text', resaltado: false, text: '', },
  ]
  
  const steps = [
    { id: "01", name: "Calzada San Juan", href: "#", status: "current" }, //depende de la respuesta de la api o la fecha
    { id: "02", name: "Avenida Petapa", href: "#", status: "upcoming" },
    { id: "04", name: "Aguilar Batres", href: "#", status: "upcoming" },
    { id: "05", name: "Zona 6", href: "#", status: "upcoming" },
    { id: "06", name: "San Cristóbal", href: "#", status: "upcoming" },
    { id: "07", name: "Villa Nueva", href: "#", status: "upcoming" },
    { id: "08", name: "El Naranjo", href: "#", status: "upcoming" },
    { id: "09", name: "Virtual a Distancia", href: "#", status: "upcoming" },
    { id: "10", name: "Amatitlán", href: "#", status: "upcoming" },
    { id: "11", name: "Jocotenango", href: "#", status: "upcoming" },
  ];
  
  const solutions = [
    {
      name: "Calzada San Juan",
      description: "Calzada San Juan",
      href: "#",
      img: "./img/logos_sedes/SanJuan.PNG",
    },
    {
      name: "Avenida Petapa",
      description: "Avenida Petapa",
      href: "#",
      img: "./img/logos_sedes/Petapa.PNG",
    },
    {
      name: "Aguilar Batres",
      description: "Aguilar Batres",
      href: "#",
      img: "./img/logos_sedes/AguilarBatres.PNG",
    },
    {
      name: "Zona 6",
      description: "Zona 6",
      href: "#",
      img: "./img/logos_sedes/Zona6.PNG",
    },
    {
      name: "San Cristóbal",
      description: "San Cristóbal",
      href: "#",
      img: "./img/logos_sedes/SanCristobal.PNG",
    },
    {
      name: "Villa Nueva",
      description: "Villa Nueva",
      href: "#",
      img: "./img/logos_sedes/VillaNueva.PNG",
    },
    {
      name: "El Naranjo",
      description: "El Naranjo",
      href: "#",
      img: "./img/logos_sedes/Naranjo.jpg",
    },
    {
      name: "Virtual a Distancia",
      description: "Virtual a Distancia",
      href: "#",
      img: "./img/logos_sedes/VirtualDistancia.PNG",
    },
    {
      name: "Amatitlán",
      description: "Amatitlán",
      href: "#",
      img: "./img/logos_sedes/Amatitlan.PNG",
    },
    {
      name: "Jocotenango",
      description: "Jocotenango",
      href: "#",
      img: "./img/logos_sedes/Jocotenango.PNG",
    },
  ];
  
  const campos = [
    { name: "Alumno", type: "text", position: "", flag: "Aspirante", id: 1 },
  ];
  
  const columnas = [
    { name: "No.", id: 0, type: "text", resaltado: false, text: "" },
    { name: "Carnet", id: 1, type: "text", resaltado: false, text: "" },
    { name: "Alumno", id: 2, type: "text", resaltado: false, text: "" },
    {
      name: "Último ciclo de estudio",
      id: 3,
      type: "text",
      resaltado: false,
      text: "",
    },
    {
      name: "Último campus de estudio",
      id: 6,
      type: "text",
      resaltado: false,
      text: "",
    },
    {
      name: "Último plan de estudio",
      id: 4,
      type: "text",
      resaltado: false,
      text: "",
    },
    {
      name: "Último grado de estudio",
      id: 5,
      type: "text",
      resaltado: false,
      text: "",
    },
    {
      name: "Selección",
      id: 998,
      type: "vista",
      resaltado: false,
      text: "Continuar",
      alt: "Continuar", // estaba seleccionar
    },
  ];

  const columnasSubmenu = [
    {
        name: "Orden",
        id: 0,
        type: "text",
        resaltado: false,
        text: "",
      },
      {
        name: "Documento",
        id: 2,
        type: "text",
        resaltado: false,
        text: "",
      },
      {
        name: "Responsable",
        id: 4,
        type: "text",
        resaltado: false,
        text: "",
      },
      {
        name: "Entregado",
        id: 3,
        type: "swicht",
        resaltado: false,
      },
  ]

  /*
  {
      name: "Estado de cuenta",
      id: 998,
      type: "vista",
      resaltado: false,
      text: "Visualizar",
      alt: "Seleccionar",
    },
  */
  export { columnasEstadoCuenta, steps, solutions, campos, columnas, columnasSubmenu };